import React, { useEffect } from 'react';
import { auth } from '../_actions/user_actions';
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

export default function withAuthentication(ComposedClass, reload, adminRoute = null) {
    function AuthenticationCheck(props) {

        let user = useSelector(state => state.user);
        const dispatch = useDispatch();
        const location = useLocation(); 
// eslint-disable-next-line react-hooks/exhaustive-deps
        useEffect(() => {

            dispatch(auth()).then(async response => {
                if (!response.payload.isAuth) {
                    if (reload) {
                        props.history.push({pathname: '/login', state: { from: location.pathname }})
                    }
                } else {
                    if (adminRoute && !response.payload.isAdmin) {
                        props.history.push('/')
                    }
                    else {
                        if (reload === false) {
                            props.history.push('/')
                        }
                    }
                }
            })
            
        }, [dispatch, props.history, user.googleAuth])

        return (
            <ComposedClass {...props} user={user} />
        )
    }
    return AuthenticationCheck
}


